module.exports = __webpack_public_path__ + "static/img/wp8_1.1cdb333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wp8_1.jpg?v=0908
// module id = q964
// module chunks = 0